<template>
  <div class="container">
    <Title></Title>
    <!-- <img src="https://lljrtj.com/images/guoqing-73.jpg" alt=""> -->
    <div class="box">
      <div class="wrapper">
        <!-- <img src="../assets/img/home/home5.svg" />
        <div class="step">
          <div class="step1"></div>
          <div class="step2"></div>
          <div class="step3"></div>
        </div>
        <div class="bottom-title">
          <p>实打实大所大所多阿达萨达阿斯顿</p>
        </div> -->
        <advertisement />
        <van-swipe
          class="my-swipe"
          @change="onChange"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item v-for="(image, index) in banner_list" :key="index">
            <img class="bannerImg" :src="baseURL + image.pc_banner" alt="" />
          </van-swipe-item>

          <template slot="indicator">
            <div class="custom-indicator">
              {{ banner_list[current].name }}
              <div>{{ current + 1 }} / {{ banner_list.length }}</div>
            </div>
          </template>
        </van-swipe>
      </div>

      <div class="serach">
        <div class="serach-box">
          <div class="serach-box-top">已诉调对接案例(件)</div>
          <div class="serach-box-bot">
            <div
              class="serachnum"
              v-for="(item, index) in case_num_list"
              :key="index"
            >
              {{ item }}
            </div>
            <div @click="path()" class="serachnow">
              <img src="../assets/img/home/home3.svg" />
              <p>案件查询</p>
            </div>
          </div>
        </div>
      </div>
      <div class="title1">
        <div class="title1-bg"></div>
      </div>
      <div class="title1-detail">
        <div class="title1-detail-box">
          <div v-for="(item, index) in ExcellentMediator" :key="index">
            <img :src="baseURL + item.avatar" />
            <p>{{ item.username }}</p>
            <p>
              <span>{{ item.age }}岁</span><span>调解员</span>
            </p>
          </div>
        </div>
      </div>
      <div class="title1">
        <div class="title2-bg"></div>
      </div>
      <div class="title2-detail">
        <div
          v-for="(item, index) in news"
          @click="paths(item.id, item.category_id)"
          :key="index"
          class="hot-news-box"
        >
          <h2>{{ item.title }}</h2>
          <div class="hot-news-content">
            <div>
              <p>
                {{ item.description }}
              </p>
              <p>
                {{ item.author }} &nbsp;
                {{ item.update_time.slice(0, 10) }}
              </p>
            </div>
            <div>
              <img :src="item.thumbImage.fullImageUrl" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="more">查看更多</div>
      <!-- 调解申请--头 -->
      <div class="applyfor">
        <h5>调解申请</h5>
        <div class="form-group">
          <p>姓名:</p>
          <input
            type="text"
            v-model="Mediation.username"
            placeholder="请输入您的姓名"
            maxlength="5"
          />
        </div>
        <div class="form-group">
          <p>身份证号:</p>
          <input
            type="text"
            v-model="Mediation.id_number"
            placeholder="请输入您的身份证号码"
            maxlength="18"
          />
        </div>
        <div class="form-group">
          <p>联系电话:</p>
          <input
            type="text"
            maxlength="11"
            v-model="Mediation.contact_mobile"
            placeholder="请输入您的联系电话"
          />
        </div>
        <textarea
          v-model="Mediation.reason"
          name=""
          id=""
          cols="30"
          rows="10"
          placeholder="请输入所需调解事由:"
        ></textarea>
        <div class="form-group">
          <h6 class="tips">
            提交本信息代表您已阅知并同意醴陵市金融纠纷调解中心进行调解，现自愿申请醴陵市金融纠纷调解中心进行调解。
          </h6>
        </div>

        <button @click="post()">提交申请</button>
      </div>
      <!-- 插图 -->
      <div class="illustration">
        <img src="../assets/img/home/home8.svg" alt="" />
      </div>
      <!-- 调解流程--头 -->
      <div>
        <div class="process">
          <p class="process-l"></p>
          <p class="process-l"></p>
          <p class="process-l"></p>
          <p class="processName">调解流程</p>
          <p class="process-r"></p>
          <p class="process-r"></p>
          <p class="process-r"></p>
        </div>
        <div class="processBody">
          <div class="plane">
            <div class="icon plane-01"></div>
            <div class="plane-text">调解申请</div>
          </div>
          <div class="arrow">
            <div class="arrow-bg"></div>
            <div></div>
          </div>
          <div class="plane">
            <div class="icon plane-02"></div>
            <div class="plane-text">案件登记</div>
          </div>
          <div class="arrow">
            <div class="arrow-bg"></div>
            <div></div>
          </div>
          <div class="plane">
            <div class="icon plane-03"></div>
            <div class="plane-text">资料审查</div>
          </div>
          <div class="arrow">
            <div class="arrow-bg"></div>
            <div></div>
          </div>
          <div class="plane">
            <div class="icon plane-04"></div>
            <div class="plane-text">案件调解</div>
          </div>
          <div class="arrow">
            <div class="arrow-bg"></div>
            <div></div>
          </div>
          <div class="plane">
            <div class="icon plane-05"></div>
            <div class="plane-text">签订协议</div>
          </div>
        </div>
      </div>
      <!-- 调解流程--尾 -->
    </div>
    <!-- 关于我们--头 -->
    <div class="aboutus">
      <div class="aboutusbgc">
        <h5>关于我们</h5>
        <p v-html="about_us_text"></p>
      </div>
    </div>
    <!-- 联系我们--头 -->
    <div class="contactus">
      <h5>联系我们</h5>
      <p>
        <span>客服电话：</span><span>{{ contact_us_mobile }}</span>
      </p>
      <p>
        <span>联系邮箱：</span><span>{{ contact_us_email }}</span>
      </p>
      <p>
        <span>公司地址：</span><span>{{ company_address }}</span>
      </p>
      <h6></h6>
    </div>
    <!-- 友情链接--头 -->
    <div class="fr-link">
      <a href="http://tingshen.court.gov.cn/">
        <span><img src="../assets/img/base/fr-link01.svg" alt=""/></span>
        <p>中国庭审公开</p>
      </a>
      <a href="http://zxgk.court.gov.cn/"
        ><img src="../assets/img/base/fr-link03.svg" alt="" />
        <p>中国执行信息公开</p>
      </a>
      <a href="https://wenshu.court.gov.cn/"
        ><img src="../assets/img/base/fr-link05.svg" alt="" />
        <p>中国裁判文书网</p>
      </a>
      <a href="https://splcgk.court.gov.cn/gzfwww/"
        ><img src="../assets/img/base/fr-link02.svg" alt="" />
        <p>中国审判流程信息公开</p>
      </a>
      <a href="http://sfj.liling.gov.cn/"
        ><img src="../assets/img/base/fr-link04.svg" alt="" />
        <p>醴陵市司法局</p>
      </a>
      <a href="http://llsfy.hunancourt.gov.cn/index.shtml"
        ><img src="../assets/img/base/fr-link06.svg" alt="" />
        <p>醴陵市人民法院</p>
      </a>
    </div>
    <!-- 底部版权信息 -->
    <copyright />
  </div>
</template>

<script>
import Title from "../components/title.vue";
import copyright from "../components/copyright.vue";
import router from "../router";
import axios from "axios";
import { Dialog, Toast } from "vant";
import advertisement from "../components/advertisement.vue";

export default {
  name: "home",
  components: {
    Title,
    copyright,
    router,
    advertisement
  },

  data() {
    return {
      about_us_text: "",
      case_num_list: [0, 0, 0, 0, 0],
      company_address: "",
      contact_us_email: "",
      contact_us_mobile: "",
      gongan_beian: "",
      gongan_link: "",
      icp_link: "",
      icp_number: "",
      // 优秀调解员
      ExcellentMediator: [
        {
          username: "",
          age: ""
        }
      ],
      banner_list: [
        {
          name: "醴陵市2022年政法基层治理培训班",
          pc_banner:
            "	https://lljrtj.com/upload/20230220/358f92d5d06d5b2a45930f727a40cb9a.png"
        }
      ],
      // 轮播下标
      current: 0,
      Mediation: {
        username: "",
        id_number: "",
        contact_mobile: "",
        reason: "",
        platform: "mobile",
        status: "1"
      },
      // 热门
      news: []
    };
  },

  mounted() {
    this.loadWebsiteInfo();
    this.getExcellentMediator();
    this.getBannerList();
    this.HotNews();
  },
  methods: {
    // 案件查询
    path() {
      this.$router.push("/CaseInquiry");
    },
    // 轮播触发事件
    onChange(index) {
      // console.log(index);
      this.current = index;
    },
    // 网站基本信息
    loadWebsiteInfo() {
      axios
        .post("/api/index/website_info", {})
        .then(res => {
          this.about_us_text = res.data.data.about_us_text;
          let case_total = res.data.data.case_total;
          this.case_num_list = [];
          while (case_total >= 1) {
            // console.log(case_total % 10);
            this.case_num_list.unshift(case_total % 10);
            case_total = parseInt(case_total / 10);
          }
          while (this.case_num_list.length <= 5) {
            this.case_num_list.unshift(0);
          }
          this.company_address = res.data.data.company_address;
          this.contact_us_email = res.data.data.contact_us_email;
          this.contact_us_mobile = res.data.data.contact_us_mobile;
          this.gongan_beian = res.data.data.gongan_beian;
          this.gongan_link = res.data.data.gongan_link;
          this.icp_link = res.data.data.icp_link;
          this.icp_number = res.data.data.icp_number;
        })
        .catch(e => {
          console.error(e);
        });
    },
    // 获取优秀调解员
    async getExcellentMediator() {
      let res = await axios.post("/api/index/mediator_list", {});
      this.ExcellentMediator = res.data.data.mediator_list;
    },

    // 获取轮播图片
    async getBannerList() {
      let res = await axios.post("/api/banner/list", {});
      this.banner_list = res.data.data.banner_list;
    },

    //  申请调解
    async post() {
      let res = await axios.post("/api/apply/add", this.Mediation);
      if (res.data.code == 1) {
        Dialog.alert({
          message: res.data.data
        });
      } else {
        Toast.fail(res.data.message);
      }
    },

    // 获取热门资讯
    async HotNews() {
      let res = await axios.post("/api/article/page_list", {
        current_page: "1",
        page_size: "3",
        is_hots: "1",
        category_id: "1"
      });
      // 日期格式处理，只保留年月日，去掉时分秒

      this.news = res.data.data.records;
    },

    // 资讯跳转
    paths(article_id, category_id) {
      this.$router.push({
        path: "/fingerpostI",
        query: { article_id, category_id }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #fff;
}

.custom-indicator {
  width: calc(100% - 10px);
  position: absolute;
  right: 0px;
  bottom: 0.36rem;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
}

>>> .van-swipe {
  color: #fff;
  font-size: 20px;
  height: 100%;
}

.bannerImgP {
  width: 100%;
  height: 100%;
}

.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 1rem;
}

.wrapper {
  width: 100%;
  /* height: 13.5rem; */
  border-radius: 0.5rem;
  margin-top: 3rem;
}

.wrapper img {
  width: 100%;
  /* height: 13.5rem; */
}

.step {
  width: 3.375rem;
  height: 0.25rem;
  position: absolute;
  bottom: 2.5rem;
  right: 1rem;
  display: flex;
  justify-content: space-between;
}

.step div {
  width: calc(100% / 3 - 0.1rem);
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0.4375rem;
}

.bottom-title {
  width: 100%;
  height: 2rem;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 0;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  text-indent: 1em;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 0.75rem;
}

.bottom-title p {
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.serach {
  width: 100%;
  height: 10.625rem;
  background: url("../assets/img/home/home2.svg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  margin-top: 1rem;
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.serach-box {
  width: 19.5rem;
  height: 5.5rem;
  font-size: 0.8125rem;
  color: #ffffff;
}

.serach-box-top,
.serach-box-bot {
  width: 100%;
  height: 50%;
}

.serach-box-bot {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.serach-box-bot div {
  float: left;
  box-sizing: border-box;
  padding: 0.5rem 0.25rem;
  border-radius: 1.2rem;
  color: #2b4ca4;
  background: #ffffff;
  font-size: 1.8125rem;
}

.serach-box-bot .serachnow {
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title1 {
  width: 100%;
  height: 1.2rem;
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

.title1-bg {
  width: 9rem;
  height: 100%;
  background: url("../assets/img/home/home4.svg");
}

.title2-bg {
  width: 7.9rem;
  height: 100%;
  background: url("../assets/img/home/home6.svg");
}

.title1-detail {
  width: 100%;
  /* height: 10.8rem; */
  display: flex;
  /* justify-content: space-between;   */
  margin-top: 1rem;
  /* overflow-x: scroll; */
}

.title1-detail-box {
  width: 100%;
  overflow: auto;
  white-space: nowrap;
}

.title1-detail-box > div {
  /* width: 100px; */
  width: calc(100% / 3 - 1rem);
  /* float: left; */
  color: #393c3f;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  display: inline-block;
  /* overflow-x: scroll; */
  margin-right: 1rem;
  /* overflow: auto; */
}

.title1-detail > div img {
  /* width: 100%; */
  width: 100px;
  height: 100px;
  /* height: 8rem; */
}

.title1-detail > div p {
  width: 80%;
  margin: 0 auto;
  height: 1.6rem;
  font-size: 1rem;
  line-height: 1.6rem;
}

.title1-detail > div p:last-child {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #5f666d;
  margin-bottom: 0.5rem;
}

.title2-detail {
  width: 100%;
  height: auto;
  margin-top: 1.5rem;
}

.hot-news-box h2 {
  margin-bottom: 1rem;
  font-size: 1rem;
  color: #393c3f;
}

.hot-news-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-direction: row;
}

.title2-detail > div {
  width: 100%;
  height: 5rem;
  margin-bottom: 0.8rem;
  display: flex;
  font-size: 0.8125rem;
  flex-direction: column;
  align-items: flex-start;
}

.hot-news-content img {
  width: 6.6875rem;
  height: 100%;
  margin-right: 0.5rem;
  border-radius: 4px;
}

.hot-news-content div:nth-child(1) {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 1rem;
}
.hot-news-content p:nth-child(1) {
  color: #5f666d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  letter-spacing: 0.5px;
  padding: 4px 0 0;
  font-weight: 700;
}

.hot-news-content p:nth-child(2) {
  color: #c0c0c0;
  font-size: 0.75rem;
}

.more {
  width: 100%;
  text-align: center;
  color: #86898d;
  font-size: 0.8125rem;
  font-weight: 700;
  margin-top: 4rem;
}

.applyfor {
  width: 100%;
  height: 21.75rem;
  background: url("../assets/img/home/home7.svg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  margin-top: 2rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
  padding: 1.25rem 1.25rem 0 1.25rem;
  color: #fff;
}

.applyfor h5 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.875rem;
  margin-bottom: 1.25rem;
}

.applyfor p {
  font-size: 0.8125rem;
  display: inline-block;
}

.applyfor div {
  margin-bottom: 0.625rem;
}

.applyfor input {
  float: right;
  width: 235px;
  height: 24px;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  padding: 0.375rem 0.375rem;
  color: #fff;
  background-color: #e04044;
}

.applyfor input:focus {
  outline: none;
}

.applyfor input::-webkit-input-placeholder {
  /* // WebKit, Blink, Edge浏览器，带input，双冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor input::-moz-placeholder {
  /* // 火狐浏览器高版本（19+），不用带input，双冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor input:-moz-placeholder {
  /* // 火狐浏览器底版本（4 to 18），不用带input，单冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor input:-ms-input-placeholder {
  /*IE浏览器底版本（10-11），带input，单冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor textarea {
  width: 100%;
  height: 4.625rem;
  opacity: 1;
  box-sizing: border-box;
  border: 1px solid #ffffff;
  padding: 0.5625rem 0.5625rem;
  font-size: 0.75rem;
  color: #fff;
  background-color: #e04044;
  resize: none;
  margin-top: 0.625rem;
}

.applyfor textarea:focus {
  outline: none;
}

.applyfor textarea::-webkit-input-placeholder {
  /* // WebKit, Blink, Edge浏览器，带input，双冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor textarea::-moz-placeholder {
  /* // 火狐浏览器高版本（19+），不用带input，双冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor textarea:-moz-placeholder {
  /* // 火狐浏览器底版本（4 to 18），不用带input，单冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor textarea:-ms-input-placeholder {
  /*IE浏览器底版本（10-11），带input，单冒号 */
  color: #fff;
  opacity: 0.6;
}

.applyfor h6 {
  margin-top: 0.5625rem;
  /* margin-bottom: 0.5625rem; */
  line-height: 1.0625rem;
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 1.0800000429153442%;
}

.applyfor button {
  display: block;
  margin: 0 auto;
  width: 5.8125rem;
  height: 1.5625rem;
  font-size: 0.75rem;
  background-color: #fff;
  color: #e04044;
  border-radius: 19px;
  opacity: 1;
  border: none;
  font-weight: 500;
}

.applyfor .form-group {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.applyfor .form-group p {
  width: 25%;
  min-width: 5rem;
}

.applyfor .form-group input {
  width: 75%;
}

.applyfor .form-group .tips {
  overflow: hidden;
  text-overflow: ellipsis;
  /* autoprefixer: ignore next */
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-inline-box;
}

.illustration img {
  margin-top: 2rem;
  width: 100%;
  height: 5.6875rem;
}

.process {
  padding-top: 1.875rem;
  text-align: center;
  margin-bottom: 1.25rem;
}

.process p {
  display: inline-block;
}

.processName {
  font-weight: 700;
  font-size: 1.125rem;
  margin: 0 0.3125rem;
}

.process-l,
.process-r {
  width: 0.25rem;
  height: 0.8294rem;
  transform: skew(-30deg);
  -webkit-transform: skew(-30deg);
  -moz-transform: skew(-30deg);
  -o-transform: skew(-30deg);
  -ms-transform: skew(-30deg);
  background-color: #e04044;
}

.processBody {
  margin: 0 1.625rem;
  display: flex;
  flex-direction: row;
}

.plane {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}

.arrow {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}

.plane-01 {
  width: 1.7875rem;
  height: 1.84rem;
  background: url(../assets/img/base/tjlc-tjsq.svg) no-repeat center center;
}

.plane-02 {
  width: 1.7875rem;
  height: 1.84rem;
  background: url(../assets/img/base/tjlc-ajdj.svg) no-repeat center center;
}

.plane-03 {
  width: 1.7875rem;
  height: 1.84rem;
  background: url(../assets/img/base/tjlc-zlsc.svg) no-repeat center center;
}

.plane-04 {
  width: 1.7875rem;
  height: 1.84rem;
  background: url(../assets/img/base/tjlc-ajtj.svg) no-repeat center center;
}

.plane-05 {
  width: 1.7875rem;
  height: 1.84rem;
  background: url(../assets/img/base/tjlc-qdxy.svg) no-repeat center center;
}

.arrow-bg {
  width: 1.7875rem;
  height: 1.84rem;
  background: url(../assets/img/base/tjlc-arrow.svg) no-repeat center center;
}

.plane div {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}

.plane-text {
  margin-top: 1.25rem;
  font-weight: 400;
  font-size: 0.875rem;
  color: #333;
  text-align: center;
}

.aboutus {
  margin-top: 2rem;
  width: 100%;
  height: 29.5rem;
  background: url(../assets/img/home/aboutus-bg.svg) no-repeat top right;
  font-weight: 400;
  font-size: 0.875rem;
  color: #fff;
  margin-bottom: 1.25rem;
}

.aboutusbgc {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  padding: 1.1875rem 2.125rem;
  box-sizing: border-box;
}

.aboutus h5 {
  font-weight: 500;
  font-size: 1rem;
}

.aboutus p {
  line-height: 1.25rem;
  margin-top: 1.375rem;
}

.contactus {
  position: relative;
  margin: 0 auto;
  width: 21.9375rem;
  /* height: 7.125rem; */
  height: auto;
  border-radius: 10px;
  opacity: 1;
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  color: #333;
  padding: 1rem 1.625rem 1.375rem 1.125rem;
  box-sizing: border-box;
}

.contactus h5 {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5625rem;
}

.contactus p {
  font-size: 0.875rem;
  color: #797979;
}

.contactus h6 {
  position: absolute;
  width: 3.4375rem;
  height: 3.4375rem;
  background: url(../assets/img/base/contactus-icon.svg) no-repeat center center;
  top: 1.25rem;
  right: 1.25rem;
}

.fr-link {
  margin-top: 2.1875rem;
  width: 100%;
  height: 20.1875rem;
  background: url(../assets/img/home/fr-bg.svg) no-repeat center center;
  background-size: cover;
  padding-top: 1.4375rem;
  padding-left: 2%;
  padding-bottom: 1.875rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  /* justify-content: space-around; */
}

.fr-link a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 5rem;
  background-color: #fff;
  margin-right: 2%;
  margin-bottom: 0.625rem;
  font-weight: 500;
  font-size: 0.5625rem;
  color: #e04044;
  text-decoration: none;
  text-align: center;
  width: 48%;
}

.fr-link a p {
  margin-top: 0.3125rem;
}
</style>



// WEBPACK FOOTER //
// src/page/home.vue